import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import FreeTrialBlockWithFloatingAsset from 'src/app/organisms/Homepage/FreeTrialBlockWithFloatingAsset/FreeTrialBlockWithFloatingAsset';

const FreeTrialBlock = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-9xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    overflow='hidden'
    data-track-section='free-trial-block'
  >
    <FreeTrialBlockWithFloatingAsset />
  </SectionLayout>
);

export default FreeTrialBlock;
